module.exports = __webpack_public_path__ + "static/media/teams.c44e6df7.svg";